import React from "react";
import { Col, Row, Form, Input, DatePicker, Select } from "antd";

function AllergyDetails() {
  const DrugOption = [
    { name: "Penicillin", value: "Penicillin" },
    { name: "Sulfonamide", value: "Sulfonamide" },
    { name: "ASA", value: "ASA" },
    { name: "NSAIDs", value: "NSAIDs" },
    { name: "Aspirin", value: "Aspirin" },
    { name: "Ibuprofen", value: "Ibuprofen" },
    { name: "Naproxen", value: "Naproxen" },
  ];

  const FoodOption = [
    { name: "Egg", value: "Egg" },
    { name: "Peanut", value: "Peanut" },
    { name: "Peanut butter", value: "Peanut butter" },
    { name: "Milk", value: "Milk" },
    { name: "Nuts", value: "Nuts" },
    { name: "Soy", value: "Soy" },
    { name: "Fish", value: "Fish" },
    { name: "Animal meat", value: "Animal meat" },
    { name: "Wheat", value: "Wheat" },
    { name: "Animal Protein", value: "Animal Protein" },
  ];

  const ChemicalOption = [
    { name: "Dyes", value: "Dyes" },
    { name: "Colour Additives", value: "Colour Additives" },
    { name: "Cosmetics", value: "Cosmetics" },
    { name: "Soap", value: "Soap" },
    { name: "Moisturiser", value: "Moisturiser" },
    { name: "Perfume", value: "Perfume" },
  ];

  const OtherOption = [
    { name: "Animal Dander", value: "Animal Dander" },
    { name: "Insect Bite", value: "Insect Bite" },
    { name: "Insect Sting", value: "Insect Sting" },
    { name: "Pollen", value: "Pollen" },
    { name: "Insect Faeces", value: "Insect Faeces" },
    { name: "House Dust Mites", value: "House Dust Mites" },
    { name: "Mite Faeces", value: "Mite Faeces" },
    { name: "Natural Rubber Latex", value: "Natural Rubber Latex" },
  ];

  return (
    <>
        <div className="h-[370px] w-[370px] m-5 border rounded-lg">
          <div className="h-[13%] bg-[#E0C1FF] flex items-center justify-center rounded p-2">
            <h1 className="font-bold text-normal text-[#1f0a30] mt-3">
              Allergy Details
            </h1>
          </div>
          <div className="h-[75%] overflow-y-scroll scrollwidth items-center bg-white border-t-2 border-t-[#9421F3]">
            <div className="border rounded-md m-3 p-2">
              <div className="text-sm">
                <p className="font-medium mx-3">
                  Drug Allergies:
                  <span className="font-semibold text-gray-500">
                    {" "}
                    Example Data
                  </span>
                </p>
              </div>
              <div className="text-sm">
                <p className="font-medium mx-3">
                  Food Allergies:
                  <span className="font-semibold text-gray-500">
                    {" "}
                    Example Data
                  </span>
                </p>
              </div>
              <div className="text-sm">
                <p className="font-medium mx-3">
                  Chemical Allergies:
                  <span className="font-semibold text-gray-500">
                    {" "}
                    Example Data
                  </span>
                </p>
              </div>
              <div className="text-sm">
                <p className="font-medium mx-3">
                  Other Allergies:
                  <span className="font-semibold text-gray-500">
                    {" "}
                    Example Data
                  </span>
                </p>
              </div>
              <div className="flex justify-center">
                <div className="font-semibold text-gray-500 text-sm mt-2">
                Onset date: <span className="font-semibold text-gray-500">2024-12-21</span>
                </div>
              </div>
            </div>
            <div className="border rounded-md m-3 p-2">
              <div className="text-sm">
                <p className="font-medium mx-3">
                  Drug Allergies:
                  <span className="font-semibold text-gray-500">
                    {" "}
                    Example Data
                  </span>
                </p>
              </div>
              <div className="text-sm">
                <p className="font-medium mx-3">
                  Food Allergies:
                  <span className="font-semibold text-gray-500">
                    {" "}
                    Example Data
                  </span>
                </p>
              </div>
              <div className="text-sm">
                <p className="font-medium mx-3">
                  Chemical Allergies:
                  <span className="font-semibold text-gray-500">
                    {" "}
                    Example Data
                  </span>
                </p>
              </div>
              <div className="text-sm">
                <p className="font-medium mx-3">
                  Other Allergies:
                  <span className="font-semibold text-gray-500">
                    {" "}
                    Example Data
                  </span>
                </p>
              </div>
              <div className="flex justify-center">
                <div className="font-semibold text-gray-500 text-sm mt-2">
                Onset date: <span className="font-semibold text-gray-500">2024-12-21</span>
                </div>
              </div>
            </div>
          </div>
          <div className="footer h-[44px] bg-[#E0C1FF] rounded"></div>
        </div>
    </>
  );
}

export default AllergyDetails;
